import { SSO_DOMAINS } from "../../configurations/application_config"

export const iss_sso_domain = (email) => {
    if(!email) return false;
    email = email.toLowerCase();
    return SSO_DOMAINS.some(domain => domain.test(email))
}